/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

/**
 * Internal dependencies
 */
import { sortObjectKeysUsingValue } from '../utils/formatters';

export const languages = sortObjectKeysUsingValue( {
	af: _x( 'Afrikaans', 'text', 'nelio-forms' ),
	sq: _x( 'Albanian', 'text', 'nelio-forms' ),
	ar: _x( 'Arabic (Standard)', 'text', 'nelio-forms' ),
	'ar-dz': _x( 'Arabic (Algeria)', 'text', 'nelio-forms' ),
	'ar-bh': _x( 'Arabic (Bahrain)', 'text', 'nelio-forms' ),
	'ar-eg': _x( 'Arabic (Egypt)', 'text', 'nelio-forms' ),
	'ar-iq': _x( 'Arabic (Iraq)', 'text', 'nelio-forms' ),
	'ar-jo': _x( 'Arabic (Jordan)', 'text', 'nelio-forms' ),
	'ar-kw': _x( 'Arabic (Kuwait)', 'text', 'nelio-forms' ),
	'ar-lb': _x( 'Arabic (Lebanon)', 'text', 'nelio-forms' ),
	'ar-ly': _x( 'Arabic (Libya)', 'text', 'nelio-forms' ),
	'ar-ma': _x( 'Arabic (Morocco)', 'text', 'nelio-forms' ),
	'ar-om': _x( 'Arabic (Oman)', 'text', 'nelio-forms' ),
	'ar-qa': _x( 'Arabic (Qatar)', 'text', 'nelio-forms' ),
	'ar-sa': _x( 'Arabic (Saudi Arabia)', 'text', 'nelio-forms' ),
	'ar-sy': _x( 'Arabic (Syria)', 'text', 'nelio-forms' ),
	'ar-tn': _x( 'Arabic (Tunisia)', 'text', 'nelio-forms' ),
	'ar-ae': _x( 'Arabic (U.A.E.)', 'text', 'nelio-forms' ),
	'ar-ye': _x( 'Arabic (Yemen)', 'text', 'nelio-forms' ),
	an: _x( 'Aragonese', 'text', 'nelio-forms' ),
	hy: _x( 'Armenian', 'text', 'nelio-forms' ),
	as: _x( 'Assamese', 'text', 'nelio-forms' ),
	ast: _x( 'Asturian', 'text', 'nelio-forms' ),
	az: _x( 'Azerbaijani', 'text', 'nelio-forms' ),
	eu: _x( 'Basque', 'text', 'nelio-forms' ),
	bg: _x( 'Bulgarian', 'text', 'nelio-forms' ),
	be: _x( 'Belarusian', 'text', 'nelio-forms' ),
	bn: _x( 'Bengali', 'text', 'nelio-forms' ),
	bs: _x( 'Bosnian', 'text', 'nelio-forms' ),
	br: _x( 'Breton', 'text', 'nelio-forms' ),
	my: _x( 'Burmese', 'text', 'nelio-forms' ),
	ca: _x( 'Catalan', 'text', 'nelio-forms' ),
	ch: _x( 'Chamorro', 'text', 'nelio-forms' ),
	ce: _x( 'Chechen', 'text', 'nelio-forms' ),
	zh: _x( 'Chinese', 'text', 'nelio-forms' ),
	'zh-hk': _x( 'Chinese (Hong Kong)', 'text', 'nelio-forms' ),
	'zh-cn': _x( 'Chinese (PRC)', 'text', 'nelio-forms' ),
	'zh-sg': _x( 'Chinese (Singapore)', 'text', 'nelio-forms' ),
	'zh-tw': _x( 'Chinese (Taiwan)', 'text', 'nelio-forms' ),
	cv: _x( 'Chuvash', 'text', 'nelio-forms' ),
	co: _x( 'Corsican', 'text', 'nelio-forms' ),
	cr: _x( 'Cree', 'text', 'nelio-forms' ),
	hr: _x( 'Croatian', 'text', 'nelio-forms' ),
	cs: _x( 'Czech', 'text', 'nelio-forms' ),
	da: _x( 'Danish', 'text', 'nelio-forms' ),
	nl: _x( 'Dutch (Standard)', 'text', 'nelio-forms' ),
	'nl-be': _x( 'Dutch (Belgian)', 'text', 'nelio-forms' ),
	en: _x( 'English', 'text', 'nelio-forms' ),
	'en-au': _x( 'English (Australia)', 'text', 'nelio-forms' ),
	'en-bz': _x( 'English (Belize)', 'text', 'nelio-forms' ),
	'en-ca': _x( 'English (Canada)', 'text', 'nelio-forms' ),
	'en-ie': _x( 'English (Ireland)', 'text', 'nelio-forms' ),
	'en-jm': _x( 'English (Jamaica)', 'text', 'nelio-forms' ),
	'en-nz': _x( 'English (New Zealand)', 'text', 'nelio-forms' ),
	'en-ph': _x( 'English (Philippines)', 'text', 'nelio-forms' ),
	'en-za': _x( 'English (South Africa)', 'text', 'nelio-forms' ),
	'en-tt': _x( 'English (Trinidad & Tobago)', 'text', 'nelio-forms' ),
	'en-gb': _x( 'English (United Kingdom)', 'text', 'nelio-forms' ),
	'en-us': _x( 'English (United States)', 'text', 'nelio-forms' ),
	'en-zw': _x( 'English (Zimbabwe)', 'text', 'nelio-forms' ),
	eo: _x( 'Esperanto', 'text', 'nelio-forms' ),
	et: _x( 'Estonian', 'text', 'nelio-forms' ),
	fo: _x( 'Faeroese', 'text', 'nelio-forms' ),
	fj: _x( 'Fijian', 'text', 'nelio-forms' ),
	fi: _x( 'Finnish', 'text', 'nelio-forms' ),
	fr: _x( 'French (Standard)', 'text', 'nelio-forms' ),
	'fr-be': _x( 'French (Belgium)', 'text', 'nelio-forms' ),
	'fr-ca': _x( 'French (Canada)', 'text', 'nelio-forms' ),
	'fr-fr': _x( 'French (France)', 'text', 'nelio-forms' ),
	'fr-lu': _x( 'French (Luxembourg)', 'text', 'nelio-forms' ),
	'fr-mc': _x( 'French (Monaco)', 'text', 'nelio-forms' ),
	'fr-ch': _x( 'French (Switzerland)', 'text', 'nelio-forms' ),
	fy: _x( 'Frisian', 'text', 'nelio-forms' ),
	fur: _x( 'Friulian', 'text', 'nelio-forms' ),
	'gd-ie': _x( 'Gaelic (Irish)', 'text', 'nelio-forms' ),
	gl: _x( 'Galacian', 'text', 'nelio-forms' ),
	ka: _x( 'Georgian', 'text', 'nelio-forms' ),
	de: _x( 'German (Standard)', 'text', 'nelio-forms' ),
	'de-at': _x( 'German (Austria)', 'text', 'nelio-forms' ),
	'de-de': _x( 'German (Germany)', 'text', 'nelio-forms' ),
	'de-li': _x( 'German (Liechtenstein)', 'text', 'nelio-forms' ),
	'de-lu': _x( 'German (Luxembourg)', 'text', 'nelio-forms' ),
	'de-ch': _x( 'German (Switzerland)', 'text', 'nelio-forms' ),
	el: _x( 'Greek', 'text', 'nelio-forms' ),
	gu: _x( 'Gujurati', 'text', 'nelio-forms' ),
	ht: _x( 'Haitian', 'text', 'nelio-forms' ),
	he: _x( 'Hebrew', 'text', 'nelio-forms' ),
	hi: _x( 'Hindi', 'text', 'nelio-forms' ),
	hu: _x( 'Hungarian', 'text', 'nelio-forms' ),
	is: _x( 'Icelandic', 'text', 'nelio-forms' ),
	id: _x( 'Indonesian', 'text', 'nelio-forms' ),
	iu: _x( 'Inuktitut', 'text', 'nelio-forms' ),
	ga: _x( 'Irish', 'text', 'nelio-forms' ),
	it: _x( 'Italian (Standard)', 'text', 'nelio-forms' ),
	'it-ch': _x( 'Italian (Switzerland)', 'text', 'nelio-forms' ),
	ja: _x( 'Japanese', 'text', 'nelio-forms' ),
	kn: _x( 'Kannada', 'text', 'nelio-forms' ),
	ks: _x( 'Kashmiri', 'text', 'nelio-forms' ),
	kk: _x( 'Kazakh', 'text', 'nelio-forms' ),
	km: _x( 'Khmer', 'text', 'nelio-forms' ),
	ky: _x( 'Kirghiz', 'text', 'nelio-forms' ),
	tlh: _x( 'Klingon', 'text', 'nelio-forms' ),
	ko: _x( 'Korean', 'text', 'nelio-forms' ),
	'ko-kp': _x( 'Korean (North Korea)', 'text', 'nelio-forms' ),
	'ko-kr': _x( 'Korean (South Korea)', 'text', 'nelio-forms' ),
	la: _x( 'Latin', 'text', 'nelio-forms' ),
	lv: _x( 'Latvian', 'text', 'nelio-forms' ),
	lt: _x( 'Lithuanian', 'text', 'nelio-forms' ),
	lb: _x( 'Luxembourgish', 'text', 'nelio-forms' ),
	mk: _x( 'FYRO Macedonian', 'text', 'nelio-forms' ),
	ms: _x( 'Malay', 'text', 'nelio-forms' ),
	ml: _x( 'Malayalam', 'text', 'nelio-forms' ),
	mt: _x( 'Maltese', 'text', 'nelio-forms' ),
	mi: _x( 'Maori', 'text', 'nelio-forms' ),
	mr: _x( 'Marathi', 'text', 'nelio-forms' ),
	mo: _x( 'Moldavian', 'text', 'nelio-forms' ),
	nv: _x( 'Navajo', 'text', 'nelio-forms' ),
	ng: _x( 'Ndonga', 'text', 'nelio-forms' ),
	ne: _x( 'Nepali', 'text', 'nelio-forms' ),
	no: _x( 'Norwegian', 'text', 'nelio-forms' ),
	nb: _x( 'Norwegian (Bokmal)', 'text', 'nelio-forms' ),
	nn: _x( 'Norwegian (Nynorsk)', 'text', 'nelio-forms' ),
	oc: _x( 'Occitan', 'text', 'nelio-forms' ),
	or: _x( 'Oriya', 'text', 'nelio-forms' ),
	om: _x( 'Oromo', 'text', 'nelio-forms' ),
	fa: _x( 'Persian/Farsi', 'text', 'nelio-forms' ),
	'fa-ir': _x( 'Persian/Iran', 'text', 'nelio-forms' ),
	pl: _x( 'Polish', 'text', 'nelio-forms' ),
	pt: _x( 'Portuguese', 'text', 'nelio-forms' ),
	'pt-br': _x( 'Portuguese (Brazil)', 'text', 'nelio-forms' ),
	pa: _x( 'Punjabi', 'text', 'nelio-forms' ),
	'pa-in': _x( 'Punjabi (India)', 'text', 'nelio-forms' ),
	'pa-pk': _x( 'Punjabi (Pakistan)', 'text', 'nelio-forms' ),
	qu: _x( 'Quechua', 'text', 'nelio-forms' ),
	rm: _x( 'Rhaeto-Romanic', 'text', 'nelio-forms' ),
	ro: _x( 'Romanian', 'text', 'nelio-forms' ),
	'ro-mo': _x( 'Romanian (Moldavia)', 'text', 'nelio-forms' ),
	ru: _x( 'Russian', 'text', 'nelio-forms' ),
	'ru-mo': _x( 'Russian (Moldavia)', 'text', 'nelio-forms' ),
	sz: _x( 'Sami (Lappish)', 'text', 'nelio-forms' ),
	sg: _x( 'Sango', 'text', 'nelio-forms' ),
	sa: _x( 'Sanskrit', 'text', 'nelio-forms' ),
	sc: _x( 'Sardinian', 'text', 'nelio-forms' ),
	gd: _x( 'Scots Gaelic', 'text', 'nelio-forms' ),
	sd: _x( 'Sindhi', 'text', 'nelio-forms' ),
	si: _x( 'Singhalese', 'text', 'nelio-forms' ),
	sr: _x( 'Serbian', 'text', 'nelio-forms' ),
	sk: _x( 'Slovak', 'text', 'nelio-forms' ),
	sl: _x( 'Slovenian', 'text', 'nelio-forms' ),
	so: _x( 'Somani', 'text', 'nelio-forms' ),
	sb: _x( 'Sorbian', 'text', 'nelio-forms' ),
	es: _x( 'Spanish', 'text', 'nelio-forms' ),
	'es-ar': _x( 'Spanish (Argentina)', 'text', 'nelio-forms' ),
	'es-bo': _x( 'Spanish (Bolivia)', 'text', 'nelio-forms' ),
	'es-cl': _x( 'Spanish (Chile)', 'text', 'nelio-forms' ),
	'es-co': _x( 'Spanish (Colombia)', 'text', 'nelio-forms' ),
	'es-cr': _x( 'Spanish (Costa Rica)', 'text', 'nelio-forms' ),
	'es-do': _x( 'Spanish (Dominican Republic)', 'text', 'nelio-forms' ),
	'es-ec': _x( 'Spanish (Ecuador)', 'text', 'nelio-forms' ),
	'es-sv': _x( 'Spanish (El Salvador)', 'text', 'nelio-forms' ),
	'es-gt': _x( 'Spanish (Guatemala)', 'text', 'nelio-forms' ),
	'es-hn': _x( 'Spanish (Honduras)', 'text', 'nelio-forms' ),
	'es-mx': _x( 'Spanish (Mexico)', 'text', 'nelio-forms' ),
	'es-ni': _x( 'Spanish (Nicaragua)', 'text', 'nelio-forms' ),
	'es-pa': _x( 'Spanish (Panama)', 'text', 'nelio-forms' ),
	'es-py': _x( 'Spanish (Paraguay)', 'text', 'nelio-forms' ),
	'es-pe': _x( 'Spanish (Peru)', 'text', 'nelio-forms' ),
	'es-pr': _x( 'Spanish (Puerto Rico)', 'text', 'nelio-forms' ),
	'es-es': _x( 'Spanish (Spain)', 'text', 'nelio-forms' ),
	'es-uy': _x( 'Spanish (Uruguay)', 'text', 'nelio-forms' ),
	'es-ve': _x( 'Spanish (Venezuela)', 'text', 'nelio-forms' ),
	sx: _x( 'Sutu', 'text', 'nelio-forms' ),
	sw: _x( 'Swahili', 'text', 'nelio-forms' ),
	sv: _x( 'Swedish', 'text', 'nelio-forms' ),
	'sv-fi': _x( 'Swedish (Finland)', 'text', 'nelio-forms' ),
	'sv-sv': _x( 'Swedish (Sweden)', 'text', 'nelio-forms' ),
	ta: _x( 'Tamil', 'text', 'nelio-forms' ),
	tt: _x( 'Tatar', 'text', 'nelio-forms' ),
	te: _x( 'Teluga', 'text', 'nelio-forms' ),
	th: _x( 'Thai', 'text', 'nelio-forms' ),
	tig: _x( 'Tigre', 'text', 'nelio-forms' ),
	ts: _x( 'Tsonga', 'text', 'nelio-forms' ),
	tn: _x( 'Tswana', 'text', 'nelio-forms' ),
	tr: _x( 'Turkish', 'text', 'nelio-forms' ),
	tk: _x( 'Turkmen', 'text', 'nelio-forms' ),
	uk: _x( 'Ukrainian', 'text', 'nelio-forms' ),
	hsb: _x( 'Upper Sorbian', 'text', 'nelio-forms' ),
	ur: _x( 'Urdu', 'text', 'nelio-forms' ),
	ve: _x( 'Venda', 'text', 'nelio-forms' ),
	vi: _x( 'Vietnamese', 'text', 'nelio-forms' ),
	vo: _x( 'Volapuk', 'text', 'nelio-forms' ),
	wa: _x( 'Walloon', 'text', 'nelio-forms' ),
	cy: _x( 'Welsh', 'text', 'nelio-forms' ),
	xh: _x( 'Xhosa', 'text', 'nelio-forms' ),
	ji: _x( 'Yiddish', 'text', 'nelio-forms' ),
	zu: _x( 'Zulu', 'text', 'nelio-forms' ),
} );
